import { type PropsWithChildren } from 'react';
import { config, ParallaxProvider } from '@adc/parallax-component-library';
import { QueryClientProvider } from '@tanstack/react-query';

import { useDefaultTheme } from '~/hooks';
import { queryClient } from '~/services/query';

export const Providers = ({ children }: PropsWithChildren) => {
  const defaultTheme = useDefaultTheme();

  return (
    <QueryClientProvider client={queryClient}>
      <ParallaxProvider
        config={config}
        locale="en-US"
        dir="ltr"
        defaultTheme={defaultTheme}
      >
        {children}
      </ParallaxProvider>
    </QueryClientProvider>
  );
};
